const MenuItemStyle = {
  display: 'flex',
  whiteSpace: 'nowrap',
  padding: '16px',
  lineHeight: 1,
  alignItems: 'center',
  maxWidth: '30em',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  cursor: 'pointer',
} as React.CSSProperties;

import * as React from 'react';
import { themedButtonText } from '../../../styles/SharedStyles';
import { ThemeString, useThemeContext } from '../../../context';

export interface MenuItemProps {
  id?: any;
  disabled?: boolean;
  hint?: string;
  onClick?: (id?: any) => void;
  children: any;
}

export function MenuItem({
  id,
  disabled,
  hint,
  onClick,
  children,
}: MenuItemProps): JSX.Element {
  const [hovered, setHovered] = React.useState<boolean>(false);

  function style(theme: ThemeString): React.CSSProperties {
    let themedStyle = { ...MenuItemStyle };
    if (hovered) {
      themedStyle = { ...themedStyle, ...themedButtonText(theme) };
    }
    return themedStyle;
  }

  const theme = useThemeContext();

  return (
    <li
      className={disabled ? 'disabled' : ''}
      style={style(theme)}
      title={hint}
      onClick={() => onClick?.(id)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
    >
      {children}
    </li>
  );
}
